<template>
  <!-- <basic-container > -->
  <div class="card-container" style="background: #f0f2f5">
    <div style="margin-bottom: 1vh; padding: 0px 0px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/index' }">&lt;</el-breadcrumb-item> -->
        <i class="el-icon-back" style="font-size: 20px; font-weight: bolder" @click="back()"></i>
      </el-breadcrumb>
    </div>

    <div class="card-row">
      <div class="card card01">
        <div class="card-row" style="font-size: 20px; font-weight: bold; margin-bottom: 2vh">
          {{ info.name }}
        </div>
        <div class="card02" style="font-size: 14px">
          <div>性别：{{ info.sex === 1 ? "男" : info.sex === 2 ? "女" : "未填写" }}</div>
          <div>手机号码：{{ info.mobile }}</div>
        </div>
        <div class="card02" style="font-size: 14px">
          <div>年龄|生日：{{ info.age }}岁 / 未填写</div>
          <div>身高|体重：{{ info.height ? info.height : "..." }}cm/{{ info.weight ? info.weight : "..." }}kg</div>
        </div>
        <div class="card02" style="margin-bottom: 0vh; margin-top: 7vh">
          <div style="font-size: 18px; font-weight: bold">用户标签</div>
          <div>
            <el-button type="primary" style="font-size: 15px" @click="toLabelTextShow">新 增</el-button>
            <el-button type="success" class="pushBtn" @click="toPush">手表消息推送</el-button>
          </div>
        </div>
        <div class="card-row">
          <div class="label01" v-for="(item, index) in labels" :key="index">
            {{ item }}
            <span @click="delLabel(index)">×</span>
          </div>
          <div class="label-placeholder" v-if="labels.length === 0">
            &nbsp;
            <!-- 空格占位 -->
          </div>
        </div>
        <div class="grid_1f_2a" v-if="labelTextShow">
          <el-input v-model="labelText" placeholder="请输入标签"></el-input>
          <div>
            <el-button type="primary" style="font-size: 15px" @click="addLabel()">保存</el-button>
            <el-button style="font-size: 15px" @click="notLabelTextShow">取消</el-button>
          </div>
        </div>
      </div>
      <div class="card card01">
        <div class="card-row" style="position: relative">
          <div class="buttons">
            <el-button :type="isSelected === 1 ? 'success' : 'default'" @click="chickDay(1)">近七天</el-button>
            <el-button :type="isSelected === 2 ? 'success' : 'default'" @click="chickDay(2)">近三天</el-button>
            <el-button :type="isSelected === 3 ? 'success' : 'default'" @click="chickDay(3)">今天</el-button>
          </div>
          <div
            id="lineChart1"
            :style="{
              width: '100%',
              height: '30vh',
              minHeight: '270px',
              minWidth: '770px',
            }"
          ></div>
        </div>
      </div>
    </div>

    <div class="card-row">
      <div class="card card03">
        <div class="card04" style="font-size: 14px">
          <div>产品型号： ( {{ device.snType }} )</div>
          <div>设备编号：{{ device.imei }}</div>
          <!-- <div>设备颜色：玛瑙黑</div> -->
        </div>
        <div class="card04" style="font-size: 14px; margin-bottom: 1vh">
          <div>状态：{{ device.status === "0" ? "未充电" + "( " + device.elecDate + " )" : device.status === "1" ? "充电中" + "( " + device.elecDate + " )" : "" }}</div>
          <div>
            当前电量：{{ device.elec }}
            {{ device.elecDate != null ? "( " + device.elecDate + " )" : "" }}
          </div>
          <div>最近使用时间：{{ device.recentDate }}</div>
        </div>
        <!-- <div class="card04" style="font-size: 14px">
          <div>用户当前设备版本号：V7.9.5</div>
        </div> -->
      </div>
    </div>

    <div class="card-row">
      <div class="card card03">
        <div class="card04" style="font-size: 14px">
          <div>
            血压校准:
            <el-button style="margin-left: 20px; background-color: #409eff; color: #fff" @click="toAddBpRecord">血压校准</el-button>
            <el-button style="margin-left: 20px" @click="toBpRecord">校准记录</el-button>
          </div>
        </div>
        <div class="card07" style="font-size: 14px; margin-bottom: 1vh">
          <div>最近校准时间：{{ recentBp.bpDate }}</div>
          <div>校准血压：{{ recentBp.bp }}</div>
        </div>
      </div>
    </div>

    <!-- 自定义弹框 -->
    <el-dialog :visible.sync="addBpRecordShow" title="血压校准" width="550px">
      <div style="margin-left: 30px; margin-right: 20px">
        <div style="display: flex; margin-bottom: 20px; align-items: center; font-size: 14px">
          收缩压 (高压) :
          <el-input placeholder="请输入收缩压" v-model="sys" clearable style="width: 230px; margin-left: 20px; margin-right: 5px"></el-input>
          mmHG
        </div>
        <div style="display: flex; margin-bottom: 30px; align-items: center; font-size: 14px">
          舒张压 (低压) :
          <el-input placeholder="请输入舒张压" v-model="dia" clearable style="width: 230px; margin-left: 20px; margin-right: 5px"></el-input>
          mmHG
        </div>
        <div style="display: flex; align-items: center; font-size: 14px">
          校准方式:
          <el-radio v-model="radio" label="1" style="margin-left: 20px">用户设备校准</el-radio>
          <el-radio v-model="radio" label="2">仅当前设备校准</el-radio>
        </div>
      </div>
      <template #footer>
        <el-button @click="addBpRecordShow = false">取消</el-button>
        <el-button type="primary" @click="addBpRecord">确认校准</el-button>
      </template>
    </el-dialog>

    <!-- 自定义弹框 -->
    <el-dialog :visible.sync="bpRecordShow" title="校准血压记录（近20条）" width="700px" top="20px">
      <div style="margin-left: 30px; margin-right: 30px">
        <avue-crud :option="option2" :data="bpRecords"></avue-crud>
      </div>
      <template #footer>
        <el-button type="primary" @click="bpRecordShow = false">确认</el-button>
      </template>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="showPushMessage" width="30%">
      <el-input type="textarea" :rows="6" placeholder="请输入推送内容" v-model="pushMessage"></el-input>
      <div class="pushModel">
        <div>推送模板:</div>
        <el-button @click="pushModel(0)">推送文案</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPushMessage = false">取 消</el-button>
        <el-button type="primary" @click="push">确 定 推 送</el-button>
      </span>
    </el-dialog>

    <div class="card-row">
      <div class="card card03">
        <div class="card-3" style="margin: 0px">
          <div>
            <div style="font-size: 18px; font-weight: bold; margin-bottom: 1vh">今日实时数据</div>
            <div style="font-size: 14px">统计时间：{{ recent.date }} 0点 ~ {{ recent.end }}</div>
            <div class="table1">
              <div class="t1_data">
                <div>心率</div>
                <div>血压</div>
                <div>血氧</div>
                <div>体温</div>
                <div>血糖</div>
              </div>
              <div class="t1_data" style="font-weight: bold">
                <div>{{ recent.heartRate ? recent.heartRate : "..." }}</div>
                <div>{{ recent.sys ? recent.sys : "..." }}/{{ recent.dia ? recent.dia : "..." }}</div>
                <div>{{ recent.bo ? recent.bo : "..." }}</div>
                <div>{{ recent.bt ? recent.bt : "..." }}</div>
                <div>{{ recent.bs ? recent.bs : "..." }}</div>
              </div>
              <div class="t1_data" style="margin-bottom: 0vh">
                <div>{{ recent.hrDate ? recent.hrDate : "..." }}</div>
                <div>{{ recent.bpDate ? recent.bpDate : "..." }}</div>
                <div>{{ recent.boDate ? recent.boDate : "..." }}</div>
                <div>{{ recent.btDate ? recent.btDate : "..." }}</div>
                <div>{{ recent.bsDate ? recent.bsDate : "..." }}</div>
              </div>
            </div>
            <div style="font-size: 18px; font-weight: bold; margin-top: 10vh; margin-bottom: 1vh">步数与热量消耗</div>
            <div style="font-size: 14px; color: #1e244c; display: flex">
              <div style="margin-right: 1vw; margin-bottom: 1vh">🏃‍♀️步数：{{ today_mo.moSn }}步/6000步</div>
              <div>💪活动消耗：{{ today_mo.moCa }}千卡/400千卡</div>
            </div>
            <div style="font-size: 14px; color: #1e244c; display: flex">运动贵在坚持，加油哦~</div>
          </div>

          <div>
            <div style="font-size: 18px; font-weight: bold; margin-bottom: 1vh">首次互动健康画像方案</div>
            <div style="font-size: 14px">
              风险评级：
              <span style="font-weight: bold; font-size: 16px" :style="{ color: getColorByRisk(result.risk) }">{{ result.risk }}</span>
            </div>
            <div class="table3">
              <div>{{ result.prefix }}</div>
              <div v-for="(item, index) in result.riskContent" :key="index" style="padding: 10px 0; font-weight: bold; font-size: 16px">
                {{ item.name }}
              </div>
              <div style="text-align: left">大白建议:上传体检或问卷</div>
              <div v-for="(item, index) in result.riskRecommend" :key="index" style="padding: 10px 0; font-weight: bold; font-size: 16px">
                {{ item }}
              </div>
            </div>
          </div>

          <div>
            <div style="font-size: 18px; font-weight: bold">今日数据汇总</div>
            <div class="table2">
              <div class="t2_data">
                <div>项目</div>
                <div>累计次数</div>
                <div>平均</div>
                <div>最高</div>
                <div>最低</div>
              </div>
              <div class="t2_data">
                <div>心率</div>
                <div>{{ today.bpAndHr.count_hr }} 次</div>
                <div>{{ today.bpAndHr.avg_hr }}</div>
                <div>{{ today.bpAndHr.max_hr }}</div>
                <div>{{ today.bpAndHr.min_hr }}</div>
              </div>
              <div class="t2_data">
                <div>血压</div>
                <div>{{ today.bpAndHr.count_dia }} 次</div>
                <div>{{ today.bpAndHr.avg_sys }} / {{ today.bpAndHr.avg_dia }}</div>
                <div>{{ today.bpAndHr.max_sys }} / {{ today.bpAndHr.max_dia }}</div>
                <div>{{ today.bpAndHr.min_sys }} / {{ today.bpAndHr.min_dia }}</div>
              </div>
              <div class="t2_data">
                <div>血氧</div>
                <div>{{ today.bo.count_bo }} 次</div>
                <div>{{ today.bo.avg_bo }}</div>
                <div>{{ today.bo.max_bo }}</div>
                <div>{{ today.bo.min_bo }}</div>
              </div>
              <div class="t2_data">
                <div>体温</div>
                <div>{{ today.bt.count_bt }} 次</div>
                <div>{{ today.bt.avg_bt }}</div>
                <div>{{ today.bt.max_bt }}</div>
                <div>{{ today.bt.min_bt }}</div>
              </div>
              <div class="t2_data">
                <div>血糖</div>
                <div>{{ today.bs.count_bs }} 次</div>
                <div>{{ today.bs.avg_bs }}</div>
                <div>{{ today.bs.max_bs }}</div>
                <div>{{ today.bs.min_bs }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="background: #fff">
      <el-button-group>
        <el-button :class="healthButton == 1 ? 'healthButton healthActive' : 'healthButton'">健康日报</el-button>
        <el-button :class="healthButton == 2 ? 'healthButton healthActive' : 'healthButton'">健康周报</el-button>
        <el-button :class="healthButton == 3 ? 'healthButton healthActive' : 'healthButton'">健康月报</el-button>
      </el-button-group>
      <!-- 心率 -->
      <div class="card-row2">
        <div class="card dataChart" style="position: relative">
          <div class="dataButtons">
            <el-date-picker style="margin-left: 10px; margin-right: 10px" v-model="heartDate" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-button @click="heartSearch()">查询</el-button>
          </div>
          <div
            id="heartChart"
            :style="{
              width: '100%',
              height: 'auto',
              minHeight: '370px',
              minWidth: '770px',
            }"
          ></div>
        </div>

        <!-- 诊断数据 -->
        <div class="card diagnosis-panel">
          <div class="diagnosis-header">
            <div>
              <div class="diagnosis-title">心电诊断数据</div>
              <div class="diagnosis-desc">{{ ecgMeterDataNew.detail || "暂无数据" }}</div>
            </div>
            <div class="diagnosis-result">{{ ecgMeterDataNew.ecgStatus || " -- " }}</div>
          </div>

          <div class="diagnosis-content">
            <div class="diagnosis-metric-panel">
              <div class="diagnosis-subtitle">核心指标</div>
              <div class="diagnosis-index-grid">
                <div class="diagnosis-index-card" v-for="item in diagnosisIndexes" :key="item.name">
                  <div class="diagnosis-index-name">{{ item.name }}</div>
                  <div class="diagnosis-index-result">
                    <span class="diagnosis-index-score" :style="{ color: item.valueColor }">{{ item.value }}</span>
                    <span class="diagnosis-index-status">{{ item.status }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="diagnosis-result-panel">
              <div class="diagnosis-subtitle">心电结果</div>
              <div class="diagnosis-status-grid">
                <div class="diagnosis-status-item" v-for="item in ecgStatusItems" :key="item.label">
                  <span class="diagnosis-status-label">{{ item.name }}</span>
                  <strong>{{ item.status || "--" }}</strong>
                </div>
              </div>

              <div class="diagnosis-subtitle diagnosis-subtitle-gap">异常筛查</div>
              <div class="diagnosis-exception-list">
                <div class="diagnosis-exception-item" v-for="item in ecgExceptionItems" :key="item.label">
                  <span>{{ item.name }}</span>
                  <strong>{{ item.status || "--" }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 血压 -->
        <div class="card dataChart" style="position: relative">
          <div class="dataButtons">
            <el-button :type="bpMedicalData === 1 ? 'success' : 'default'" @click="chickBpMedicalData(1)">医疗数据</el-button>
            <el-button :type="bpNotMedicalData === 1 ? 'success' : 'default'" @click="chickBpNotMedicalData(1)">非医疗数据</el-button>
            <el-date-picker style="margin-left: 10px; margin-right: 10px" v-model="bpDate" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-button @click="bpSearch()">查询</el-button>
          </div>
          <div
            id="bpChart"
            :style="{
              width: '100%',
              height: 'auto',
              minHeight: '370px',
              minWidth: '770px',
            }"
          ></div>
        </div>

        <!-- 血糖 -->
        <div class="card dataChart" style="position: relative">
          <div class="dataButtons">
            <el-button :type="bsMedicalData === 1 ? 'success' : 'default'" @click="chickBsMedicalData(1)">医疗数据</el-button>
            <el-button :type="bsNotMedicalData === 1 ? 'success' : 'default'" @click="chickBsNotMedicalData(1)">非医疗数据</el-button>
            <el-date-picker style="margin-left: 10px; margin-right: 10px" v-model="bsDate" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-button @click="bsSearch()">查询</el-button>
          </div>
          <div
            id="bsChart"
            :style="{
              width: '100%',
              height: 'auto',
              minHeight: '370px',
              minWidth: '770px',
            }"
          ></div>
        </div>

        <!-- 血氧 -->
        <div class="card dataChart" style="position: relative">
          <div class="dataButtons">
            <el-button :type="boMedicalData === 1 ? 'success' : 'default'" @click="chickBoMedicalData(1)">医疗数据</el-button>
            <el-button :type="boNotMedicalData === 1 ? 'success' : 'default'" @click="chickBoNotMedicalData(1)">非医疗数据</el-button>
            <el-date-picker style="margin-left: 10px; margin-right: 10px" v-model="boDate" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-button @click="boSearch()">查询</el-button>
          </div>
          <div
            id="boChart"
            :style="{
              width: '100%',
              height: 'auto',
              minHeight: '370px',
              minWidth: '770px',
            }"
          ></div>
        </div>

        <!-- 温度 -->
        <div class="card dataChart" style="position: relative">
          <div class="dataButtons">
            <el-date-picker style="margin-left: 10px; margin-right: 10px" v-model="btDate" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-button @click="btSearch()">查询</el-button>
          </div>
          <div
            id="btChart"
            :style="{
              width: '100%',
              height: 'auto',
              minHeight: '370px',
              minWidth: '770px',
            }"
          ></div>
        </div>

        <!-- 睡眠 -->
        <div class="card dataChart" style="position: relative">
          <div class="dataButtons">
            <el-date-picker style="margin-left: 10px; margin-right: 10px" v-model="sleepDate" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-button @click="sleepSearch()">查询</el-button>
          </div>
          <div
            id="sleepChart"
            :style="{
              width: '100%',
              height: 'auto',
              minHeight: '370px',
              minWidth: '770px',
            }"
          ></div>
        </div>

        <!-- 步数 -->
        <div class="card dataChart" style="position: relative">
          <div class="dataButtons">
            <el-date-picker style="margin-left: 10px; margin-right: 10px" v-model="moDate" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-button @click="moSearch()">查询</el-button>
          </div>
          <div
            id="moChart"
            :style="{
              width: '100%',
              height: 'auto',
              minHeight: '370px',
              minWidth: '770px',
            }"
          ></div>
        </div>
      </div>
    </div>

    <!-- <div class="card-row">
      <div class="card card03">
        <div class="card-row" style="height: 100px">范裕晨</div>
      </div>

      <div class="card card-50" style="position: relative">
        <div id="columnChart1" :style="{ width: '100%', height: '40vh' }"></div>
      </div>
      <div class="card card-20">
        <div id="pieChart1" :style="{ width: '100%', height: '40vh' }"></div>
      </div>
    </div>
    <div class="card-row">
      <div class="card card-20">
        <div id="columnChart2" :style="{ width: '100%', height: '40vh' }"></div>
      </div>
      <div class="card card-20">
        <div id="pieChart2" :style="{ width: '100%', height: '40vh' }"></div>
      </div>
      <div class="card card-50" style="position: relative"></div>
    </div> -->
  </div>
  <!-- </basic-container> -->
</template>

<script>
import { getElec, getLabel, addLabel, delLabel, getDataDetail, getWatchDetail, getBpCalibrationRecordsLimit, bloodCalibration, getSleepData, pushMessage, getQaResult } from "@/api/health/manage";
import { heDataValueNew, bpDataValueNew } from "../../api/health/bpmeterdata";
import { bsDataValueNew, boDataValueNew, btDataValueNew, moDataValueNew } from "../../api/health/datashow";
import { getEcgMeterData } from "../../api/health/ecgMeterDataNew";
import func from "@/util/func";

export default {
  name: "ThreeCardLayout",
  data() {
    return {
      wxUserId: this.$route.query.wxUserId,
      wxUserid: this.$route.query.wxUserId,
      imei: this.$route.query.imei,
      snType: this.$route.query.snType,
      info: {},
      device: {},
      recent: {},
      labels: [],
      labelText: "",
      labelTextShow: false,
      isSelected: 3, // 1七天 2三天 3今天
      today: {
        bpAndHr: {
          avg_dia: "",
          avg_hr: "",
          avg_sys: "",
          count_dia: "0",
          count_hr: "0",
          count_sys: "0",
          max_dia: "",
          max_hr: "",
          max_sys: "",
          min_dia: "",
          min_hr: "",
          min_sys: "",
        },
        bo: {
          avg_bo: "",
          count_bo: "0",
          max_bo: "",
          min_bo: "",
        },
        bs: {
          avg_bs: "",
          count_bs: "0",
          max_bs: "",
          min_bs: "",
        },
        bt: {
          avg_bt: "",
          count_bt: "0",
          max_bt: "",
          min_bt: "",
        },
      },
      today_mo: {
        moSn: 0,
        moCa: 0,
      },
      healthButton: 1,
      params: {
        wxUserId: "",
        week: "",
        type: "1",
        jkStatus: "",
        beginDate: "",
        endDate: "",
      },
      bps: [],
      bos: [],
      bss: [],
      bts: [],
      mos: [],
      hearts: [],
      heartDate: [],
      bpDate: [],
      bsDate: [],
      boDate: [],
      btDate: [],
      moDate: [],
      addBpRecordShow: false,
      sys: "",
      dia: "",
      radio: "1",
      bpRecordShow: false,
      bpRecords: [],
      recentBp: {
        bpDate: "",
        bp: "",
      },
      option2: {
        align: "center", // 全局居中
        tip: false,
        border: true,
        // index: true,
        viewBtn: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        menu: false,
        // selection: true,
        refreshBtn: false, // 隐藏刷新按钮
        columnBtn: false, // 隐藏列显示隐藏按钮
        column: [
          {
            label: "校准数据",
            prop: "bp",
          },
          {
            label: "校准时间",
            prop: "bpDate",
          },
        ],
      },
      sleeps: [],
      sleepDate: [],
      showPushMessage: false,
      pushMessage: "",

      bpMedicalData: 1,
      bpNotMedicalData: 1,
      bsMedicalData: 1,
      bsNotMedicalData: 1,
      boMedicalData: 1,
      boNotMedicalData: 1,

      result: {},
      diagnosisIndexes: [
        {
          name: "负荷指数",
          value: "--",
          status: "",
          valueColor: "#2f95e8",
        },
        {
          name: "HRV指数",
          value: "--",
          status: "",
          valueColor: "#2f95e8",
        },
        {
          name: "压力指数",
          value: "--",
          status: "",
          valueColor: "#2f95e8",
        },
        {
          name: "身体指数",
          value: "--",
          status: "",
          valueColor: "#2f95e8",
        },
        {
          name: "交感神经和副交感神经活跃指数",
          value: "--",
          status: "",
          valueColor: "#2f95e8",
        },
        {
          name: "呼吸率",
          value: "--",
          status: "",
          valueColor: "#2f95e8",
        },
      ],
      ecgStatusItems: [
        { name: "心电图状态", status: "--" },
        { name: "心率状态", status: "--" },
        { name: "节律", status: "--" },
        { name: "是否心房颤动", status: "--" },
      ],
      ecgExceptionItems: [
        { name: "心室扑动", status: "--" },
        { name: "交界性早搏", status: "--" },
        { name: "交界性逸搏", status: "--" },
        { name: "室性早搏", status: "--" },
        { name: "室性逸搏", status: "--" },
        { name: "左束支传导阻滞", status: "--" },
        { name: "右束支传导阻滞", status: "--" },
        { name: "房性早搏", status: "--" },
        { name: "房性逸搏", status: "--" },
      ],
      ecgMeterDataNew: {},
    };
  },
  created() {
    this.params.wxUserId = this.$route.query.wxUserId || ""; // eslint-disable-line no-unused-vars
    this.params.week = this.$route.query.meterDate || ""; // eslint-disable-line no-unused-vars
    this.params.jkStatus = this.$route.query.jkStatus || "";
    this.params.beginDate = this.$route.query.beginDate || "";
    this.params.endDate = this.$route.query.endDate || "";
  },
  mounted() {
    this.onload();
    this.chickDay(3);
    this.getLabel();
    this.bpRecord();
  },
  methods: {
    onload() {
      const wxUserId = this.$route.query.wxUserId;
      const imei = this.$route.query.imei;

      let end = new Date();
      end = end.toISOString().split("T")[0];
      let start = new Date();
      start.setDate(start.getDate() - 365);
      start = start.toISOString().split("T")[0];

      this.params.beginDate = start;
      this.params.endDate = end;

      getDataDetail(wxUserId).then((res) => {
        const wxUserId = window.localStorage.getItem("pcUserId");
        if (wxUserId === "2043870969731301377") {
          res.data.userJk.name = func.maskName(res.data.userJk.name);
          res.data.userJk.mobile = func.maskPhone(res.data.userJk.mobile);
        }
        this.info = res.data.userJk;
        this.recent = res.data.recent;
        this.today = res.data.today;
        this.today_mo = res.data.today_mo;
      });

      getWatchDetail(wxUserId, imei).then((res) => {
        this.device = res.data;
      });

      // 首次互动
      getQaResult(wxUserId).then((res) => {
        this.result = res.data;
      });

      // 心率数据
      heDataValueNew(this.params).then((res) => {
        this.hearts = res.data;
        this.heartChart(0);
      });

      // 血压数据
      bpDataValueNew(this.params).then((res) => {
        this.bps = res.data;
        this.bpChart(0);
      });

      // 血氧数据
      boDataValueNew(this.params).then((res) => {
        this.bos = res.data;
        this.boChart(0);
      });

      // 血糖数据
      bsDataValueNew(this.params).then((res) => {
        this.bss = res.data;
        this.bsChart(0);
      });

      // 温度
      btDataValueNew(this.params).then((res) => {
        this.bts = res.data;
        this.btChart(0);
      });

      // 步数
      moDataValueNew(this.params).then((res) => {
        this.mos = res.data;
        this.moChart(0);
      });

      // 睡眠
      getSleepData(this.params).then((res) => {
        this.sleeps = res.data;
        this.sleepChart(0);
      });

      this.getEcgMeterData(wxUserId);
    },

    getEcgMeterData(wxUserId) {
      getEcgMeterData(wxUserId).then((res) => {
        if (res.data) {
          this.ecgMeterDataNew = res.data.ecgMeterDataNew;
          this.diagnosisIndexes = res.data.diagnosis;
          this.ecgStatusItems = res.data.ecgStatusList;
          this.ecgExceptionItems = res.data.ecgSymptom;
        }
      });
    },

    getColorByRisk(risk) {
      switch (risk) {
        case "高风险":
          return "red";
        case "中风险":
          return "orange";
        case "低风险":
          return "green";
        default:
          return "black";
      }
    },

    push(done) {
      this.$confirm("确认推送？")
        .then((_) => {
          pushMessage(this.device.imei, this.pushMessage, "大白提醒").then((res) => {
            if (res.success) this.$message.success("推送成功");
            this.showPushMessage = false;
          });
          done();
        })
        .catch((_) => {});
    },

    pushModel() {
      this.$message.error("功能未完善");
    },

    toPush() {
      const snType = ["BT01", "复云手表"];
      if (this.device && this.device.snType && snType.includes(this.device.snType)) {
        this.showPushMessage = true;
        this.pushMessage = "";
        // getDeviceToPush(this.wxUserId).then(res => {
        //   console.log(res)
        // })
      } else {
        this.$message.error("此功能为4G手表和复云手表功能");
      }
    },

    heartSearch() {
      if (this.heartDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.heartDate[0] || "";
        this.params.endDate = this.heartDate[1] || "";
      }
      heDataValueNew(this.params).then((res) => {
        this.hearts = res.data;
        let index = 0;
        if (this.params.beginDate === this.params.endDate && this.params.beginDate !== "") {
          index = 1;
        }
        this.heartChart(index);
      });
    },

    bpSearch() {
      if (this.bpDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.bpDate[0] || "";
        this.params.endDate = this.bpDate[1] || "";
      }
      this.params.bpMedicalData = this.bpMedicalData;
      this.params.bpNotMedicalData = this.bpNotMedicalData;
      bpDataValueNew(this.params).then((res) => {
        this.bps = res.data;
        let index = 0;
        if (this.params.beginDate === this.params.endDate && this.params.beginDate !== "") {
          index = 1;
        }
        this.bpChart(index);
      });
    },

    bsSearch() {
      if (this.bsDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.bsDate[0] || "";
        this.params.endDate = this.bsDate[1] || "";
      }
      this.params.bsMedicalData = this.bsMedicalData;
      this.params.bsNotMedicalData = this.bsNotMedicalData;
      bsDataValueNew(this.params).then((res) => {
        this.bss = res.data;
        let index = 0;
        if (this.params.beginDate === this.params.endDate && this.params.beginDate !== "") {
          index = 1;
        }
        this.bsChart(index);
      });
    },

    boSearch() {
      if (this.boDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.boDate[0] || "";
        this.params.endDate = this.boDate[1] || "";
      }
      this.params.boMedicalData = this.boMedicalData;
      this.params.boNotMedicalData = this.boNotMedicalData;
      boDataValueNew(this.params).then((res) => {
        this.bos = res.data;
        let index = 0;
        if (this.params.beginDate === this.params.endDate && this.params.beginDate !== "") {
          index = 1;
        }
        console.log("boSearch", this.bos);
        this.boChart(index);
      });
    },

    btSearch() {
      if (this.btDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.btDate[0] || "";
        this.params.endDate = this.btDate[1] || "";
      }
      btDataValueNew(this.params).then((res) => {
        this.bts = res.data;
        let index = 0;
        if (this.params.beginDate === this.params.endDate && this.params.beginDate !== "") {
          index = 1;
        }
        this.btChart(index);
      });
    },

    moSearch() {
      if (this.moDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.moDate[0] || "";
        this.params.endDate = this.moDate[1] || "";
      }
      moDataValueNew(this.params).then((res) => {
        this.mos = res.data;
        let index = 0;
        if (this.params.beginDate === this.params.endDate && this.params.beginDate !== "") {
          index = 1;
        }
        this.moChart(index);
      });
    },

    sleepSearch() {
      if (this.sleepDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.sleepDate[0] || "";
        this.params.endDate = this.sleepDate[1] || "";
      }
      getSleepData(this.params).then((res) => {
        this.sleeps = res.data;
        let index = 0;
        if (this.params.beginDate === this.params.endDate && this.params.beginDate !== "") {
          index = 1;
        }
        this.sleepChart(index);
      });
    },

    getLabel() {
      getLabel(this.wxUserid).then((res) => {
        this.labels = res.data;
      });
    },

    addLabel() {
      if (this.labelText === "null" || this.labelText === "") {
        this.$message({
          type: "error",
          message: "输入为空!",
        });
      } else {
        addLabel(this.wxUserid, this.labelText).then((res) => {
          this.labels = res.data;
          this.labelText = "";
        });
        this.$message({
          type: "success",
          message: "添加成功!",
        });
      }
    },

    delLabel(index) {
      this.$confirm("确定删除该用户标签?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delLabel(this.wxUserid, index).then((res) => {
          this.labels = res.data;
        });
        this.$message({
          type: "success",
          message: "删除成功!",
        });
      });
    },

    chickDay(index) {
      this.isSelected = index;
      let day = 1;
      if (index === 1) day = 7;
      else if (index === 2) day = 3;
      else day = 1;

      const imei = this.$route.query.imei;
      getElec(imei, day).then((res) => {
        this.elec = res.data;
        this.lineChart1(day);
      });
    },

    chickBpMedicalData() {
      if (this.bpMedicalData === 1) {
        this.bpMedicalData = 0;
      } else {
        this.bpMedicalData = 1;
      }

      this.bpSearch();
    },

    chickBpNotMedicalData() {
      if (this.bpNotMedicalData === 1) {
        this.bpNotMedicalData = 0;
      } else {
        this.bpNotMedicalData = 1;
      }
      this.bpSearch();
    },

    chickBoMedicalData() {
      if (this.boMedicalData === 1) {
        this.boMedicalData = 0;
      } else {
        this.boMedicalData = 1;
      }

      this.boSearch();
    },

    chickBoNotMedicalData() {
      if (this.boNotMedicalData === 1) {
        this.boNotMedicalData = 0;
      } else {
        this.boNotMedicalData = 1;
      }
      this.boSearch();
    },

    chickBsMedicalData() {
      if (this.bsMedicalData === 1) {
        this.bsMedicalData = 0;
      } else {
        this.bsMedicalData = 1;
      }

      this.bsSearch();
    },

    chickBsNotMedicalData() {
      if (this.bsNotMedicalData === 1) {
        this.bsNotMedicalData = 0;
      } else {
        this.bsNotMedicalData = 1;
      }
      this.bsSearch();
    },

    lineChart1(day) {
      const date = [];
      const elec = [];
      const isElec = [];
      // 准备数据
      for (let i = 1; i < this.elec.length; i++) {
        if (this.elec[i].elec !== this.elec[i - 1].elec) {
          date.push(this.elec[i].date);
          if (this.elec[i].isElec === "0") {
            elec.push(this.elec[i].elec);
            isElec.push(null);
          } else {
            elec.push(null);
            isElec.push(this.elec[i].elec);
          }
        }
      }

      const myChart = this.$echarts.init(document.getElementById("lineChart1"));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: "0%",
          right: "5%",
          bottom: "1%",
          top: "15%",
          containLabel: true, // 确保坐标轴标签显示在grid区域内
        },
        title: {
          text: "电量使用详情",
          left: "left",
          textStyle: {
            fontSize: 15,
            // fontWeight: "bold",
          },
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            // 过滤掉值为null或undefined的系列
            const validParams = params.filter((item) => item.value !== null && item.value !== undefined);
            let result = "";
            if (validParams.length > 0) {
              result = validParams[0].axisValue + "<br/>";
              validParams.forEach((item) => {
                result += `${item.marker}${item.seriesName}: ${item.value}`;
              });
            }
            return result;
          },
        },
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: date,
          axisLabel: {
            // 修改x轴标签
            // interval: 0,
            interval: "auto",
            rotate: day === 1 ? 0 : 90,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 100,
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "电量",
            type: "line",
            data: elec,
            stack: "总量",
            // areaStyle: {},
            symbol: elec.length === 1 ? "" : "none",
            lineStyle: {
              color: "green",
              width: 2,
              type: "solid",
            },
          },
          {
            name: "电量(充电中)",
            type: "line",
            data: isElec,
            stack: "总量",
            // areaStyle: {},
            symbol: isElec.length === 1 ? "" : "none",
            lineStyle: {
              color: "red",
              width: 2,
              type: "dotted",
            },
          },
        ],
        color: ["green", "red"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    // day: 1-x轴横向显示 不显示年月日  其他-纵向显示
    heartChart(day) {
      const myChart = this.$echarts.init(document.getElementById("heartChart"));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: "0%",
          right: "3%",
          bottom: "1%",
          top: "15%",
          containLabel: true, // 确保坐标轴标签显示在grid区域内
        },
        title: {
          text: "心率数据",
          left: "left",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666666",
            // fontWeight: "bold",
          },
        },
        // 右上角 转为数据工具 的小图标
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.hearts.map((v) => v.meterDate),
          axisLabel: {
            // 修改x轴标签
            formatter: function (value) {
              return day === 1 ? value.substring(11, 16) : value;
            },
            // interval: 0,
            interval: "auto",
            rotate: day === 1 ? 0 : 90,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 30,
          max: 200,
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "心率",
            type: "line",
            data: this.hearts.map((v) => v.avgHeartRate),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            stack: "总量",
            // areaStyle: {},
            symbol: this.hearts.length === 1 ? "" : "none",
            lineStyle: {
              color: "#1BC1A4",
              width: 1,
              type: "solid",
            },
          },
        ],
        color: ["#1BC1A4"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    bpChart(day) {
      const devices = ["", "手动录入", "复云手表", "一体机", "脉搏波血压计", "大的血压站", "小的房颤血压计", "数字人", "小的血压计", "心电图血压计", "蓝牙手表", "4G手表", "三诺血压计", "wifi血压计", "4G手表(BT01)", "蓝牙气囊", "辰浩血压计", "4G气囊手表", "蓝牙光电"];

      const sys_dia = [];
      for (let i = 0; i < this.bps.length; i++) {
        const diff = this.bps[i].avgSystolic - this.bps[i].avgDiastolic;
        sys_dia.push(diff);
      }

      const myChart = this.$echarts.init(document.getElementById("bpChart"));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: "0%",
          right: "3%",
          bottom: "1%",
          top: "15%",
          containLabel: true, // 确保坐标轴标签显示在grid区域内
        },
        title: {
          text: "血压数据",
          left: "left",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666666",
            // fontWeight: "bold",
          },
          formatter: (params) => {
            const idx = params[0].dataIndex;
            let html = ``;
            if (day === 1) {
              html = `${idx}<br>`;
              const device = devices[this.bps[idx].deviceType] || "未知";
              html = `设备类型：${device}<br>`;
            }
            params.forEach((p) => {
              html += `${p.marker} ${p.seriesName}: ${p.value}<br>`;
            });
            return html;
          },
        },
        // 右上角 转为数据工具 的小图标
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.bps.map((v) => v.meterDate),
          axisLabel: {
            // 修改x轴标签
            formatter: function (value) {
              return day === 1 ? value.substring(11, 16) : value;
            },
            // interval: 0,
            interval: "auto",
            rotate: day === 1 ? 0 : 90,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 180,
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "收缩压",
            type: "line",
            data: this.bps.map((v) => v.avgSystolic),
            // symbol: this.hearts.length === 1 ? "" : "none",
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            lineStyle: {
              color: "#738BD6",
              width: 2,
              type: "solid",
            },
            symbol: "circle",
          },
          {
            name: "舒张压",
            type: "line",
            data: this.bps.map((v) => v.avgDiastolic),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            // symbol: this.hearts.length === 1 ? "" : "none",
            lineStyle: {
              color: "#91CC75",
              width: 2,
              type: "solid",
            },
            symbol: "circle",
          },
          {
            name: "压差",
            type: "line",
            data: sys_dia,
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            // areaStyle: {},
            // symbol: this.hearts.length === 1 ? "" : "none",
            lineStyle: {
              color: "#FAC857",
              width: 2,
              type: "solid",
            },
            symbol: "circle",
          },
        ],
        color: ["#738BD6", "#91CC75", "#FAC857"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    bsChart(day) {
      const devices = ["", "手动录入", "手表", "一体机设备", "三诺血糖仪(持续监测CGM)", "三合一设备", "三诺4G血糖仪", "app蓝牙手表"];

      const myChart = this.$echarts.init(document.getElementById("bsChart"));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: "0%",
          right: "3%",
          bottom: "1%",
          top: "15%",
          containLabel: true, // 确保坐标轴标签显示在grid区域内
        },
        title: {
          text: "血糖数据",
          left: "left",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666666",
            // fontWeight: "bold",
          },
          formatter: (params) => {
            const idx = params[0].dataIndex;
            let html = ``;
            if (day === 1) {
              html = `${idx}<br>`;
              const device = devices[this.bss[idx].deviceType] || "未知";
              html = `设备类型：${device}<br>`;
            }
            params.forEach((p) => {
              html += `${p.marker} ${p.seriesName}: ${p.value}<br>`;
            });
            return html;
          },
        },
        // 右上角 转为数据工具 的小图标
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.bss.map((v) => v.meterDate),
          axisLabel: {
            // 修改x轴标签
            formatter: function (value) {
              return day === 1 ? value.substring(11, 16) : value;
            },
            // interval: 0,
            interval: "auto",
            rotate: day === 1 ? 0 : 90,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 18,
          max: 0,
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "血糖",
            type: "line",
            data: this.bss.map((v) => v.avgBsValue),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            // areaStyle: {},
            symbol: this.hearts.length === 1 ? "" : "none",
            lineStyle: {
              color: "#5274CF",
              width: 2,
              type: "solid",
            },
          },
        ],
        color: ["#5274CF"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    boChart(day) {
      const devices = ["", "手动录入", "早期4G手表", "复云手表", "一体机设备", "BT01手表", "app", "蓝牙", "新蓝牙", "4G气囊手表"];

      const myChart = this.$echarts.init(document.getElementById("boChart"));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: "0%",
          right: "3%",
          bottom: "1%",
          top: "15%",
          containLabel: true, // 确保坐标轴标签显示在grid区域内
        },
        title: {
          text: "血氧数据",
          left: "left",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666666",
            // fontWeight: "bold",
          },
          formatter: (params) => {
            const idx = params[0].dataIndex;
            let html = ``;
            if (day === 1) {
              html = `${idx}<br>`;
              const device = devices[this.bos[idx].deviceType] || "未知";
              html = `设备类型：${device}<br>`;
            }
            params.forEach((p) => {
              html += `${p.marker} ${p.seriesName}: ${p.value}<br>`;
            });
            return html;
          },
        },
        // 右上角 转为数据工具 的小图标
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.bos.map((v) => v.meterDate),
          axisLabel: {
            // 修改x轴标签
            formatter: function (value) {
              return day === 1 ? value.substring(11, 16) : value;
            },
            // interval: 0,
            interval: "auto",
            rotate: day === 1 ? 0 : 90,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 80,
          max: 110,
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "血氧",
            type: "line",
            data: this.bos.map((v) => v.avgBoValue),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            // areaStyle: {},
            symbol: this.hearts.length === 1 ? "" : "none",
            lineStyle: {
              color: "#1BC1A4",
              width: 2,
              type: "solid",
            },
          },
        ],
        color: ["#1BC1A4"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    btChart(day) {
      const myChart = this.$echarts.init(document.getElementById("btChart"));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: "0%",
          right: "3%",
          bottom: "1%",
          top: "15%",
          containLabel: true, // 确保坐标轴标签显示在grid区域内
        },
        title: {
          text: "体温数据",
          left: "left",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666666",
            // fontWeight: "bold",
          },
        },
        // 右上角 转为数据工具 的小图标
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.bts.map((v) => v.meterDate),
          axisLabel: {
            // 修改x轴标签
            formatter: function (value) {
              return day === 1 ? value.substring(11, 16) : value;
            },
            // interval: 0,
            interval: "auto",
            rotate: day === 1 ? 0 : 90,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 42,
          max: 30,
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "体温",
            type: "line",
            data: this.bts.map((v) => v.avgBtValue),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            // areaStyle: {},
            symbol: this.hearts.length === 1 ? "" : "none",
            lineStyle: {
              color: "#FAC857",
              width: 2,
              type: "solid",
            },
          },
        ],
        color: ["#FAC857"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    moChart(day) {
      const myChart = this.$echarts.init(document.getElementById("moChart"));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: "0%",
          right: "3%",
          bottom: "1%",
          top: "15%",
          containLabel: true, // 确保坐标轴标签显示在grid区域内
        },
        title: {
          text: "运动数据",
          left: "left",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666666",
            // fontWeight: "bold",
          },
        },
        // 右上角 转为数据工具 的小图标
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.mos.map((v) => v.meterDate),
          axisLabel: {
            // 修改x轴标签
            formatter: function (value) {
              return day === 1 ? value.substring(11, 16) : value;
            },
            // interval: 0,
            interval: "auto",
            rotate: day === 1 ? 0 : 90,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: this.mos.length === 0 ? 5000 : undefined,
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "步数",
            type: "line",
            data: this.mos.map((v) => v.avgMoValue),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            markLine: {
              data: [
                {
                  type: "max",
                  lineStyle: {
                    type: "dashed",
                    color: "#91CC75",
                  },
                  label: {
                    formatter: "最大步数: {c} 步",
                    position: "middle",
                  },
                },
              ],
            },
            // areaStyle: {},
            symbol: this.hearts.length === 1 ? "" : "none",
            lineStyle: {
              color: "#91CC75",
              width: 2,
              type: "solid",
            },
          },
        ],
        color: ["#91CC75"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    sleepChart(day) {
      const myChart = this.$echarts.init(document.getElementById("sleepChart"));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: "0%",
          right: "3%",
          bottom: "1%",
          top: "15%",
          containLabel: true, // 确保坐标轴标签显示在grid区域内
        },
        title: {
          text: "睡眠数据",
          left: "left",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666666",
            // fontWeight: "bold",
          },
        },
        // 右上角 转为数据工具 的小图标
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.sleeps.map((v) => v.sleepDate),
          axisLabel: {
            // 修改x轴标签
            formatter: function (value) {
              return value.substring(0, 11);
            },
            interval: "auto",
            rotate: day === 1 ? 0 : 90,
            margin: 7,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: this.mos.length === 0 ? 300 : undefined,
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "睡眠总时长(分钟)",
            type: "bar",
            data: this.sleeps.map((v) => v.totalTime),
          },
          {
            name: "浅睡时长(分钟)",
            type: "bar",
            data: this.sleeps.map((v) => v.lightTime),
          },
          {
            name: "深睡时长(分钟)",
            type: "bar",
            data: this.sleeps.map((v) => v.deepTime),
          },
          {
            name: "快速眼动时长(分钟)",
            type: "bar",
            data: this.sleeps.map((v) => v.remTime),
          },
          {
            name: "途清醒时长(分钟)",
            type: "bar",
            data: this.sleeps.map((v) => v.wakeupTime),
          },
        ],
        color: ["#91CC75", "#BC80EC", "#8A2BE2", "#ACAFF0", "#CEBAF5"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    toLabelTextShow() {
      this.labelTextShow = true;
    },

    notLabelTextShow() {
      this.labelTextShow = false;
    },

    back() {
      this.$router.go(-1);
    },

    toBpRecord() {
      this.bpRecordShow = true;
      this.bpRecord();
    },

    bpRecord() {
      // getBpCalibrationRecordsLimit(this.wxUserid, 20, " ").then((res) => {
      getBpCalibrationRecordsLimit(this.wxUserid, 20, this.imei ? this.imei : " ").then((res) => {
        if (res.success) {
          this.bpRecords = res.data;
          if (res.data.length !== 0) {
            this.recentBp = res.data[0];
          }
        }
      });
    },

    toAddBpRecord() {
      this.addBpRecordShow = true;
    },

    addBpRecord() {
      this.addBpRecordShow = false;
      const sys = Number(this.sys);
      const dia = Number(this.dia);
      if (isNaN(sys) || isNaN(dia) || sys === 0 || dia === 0) {
        this.$message.error("收缩压和舒张压输入错误！");
      } else {
        const bp = {
          wxUserId: this.wxUserid,
          sys: sys,
          dia: dia,
        };

        bloodCalibration(bp).then((res) => {
          if (res.success) {
            if (res.data === true) {
              this.$message({
                message: "校准成功！",
                type: "success",
              });
            } else {
              this.$message.error(res.data);
            }
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.card-container {
  width: 100%;
  max-width: 100vw; /* 可根据需要调整最大宽度 */
  margin: 0 auto;
  padding: 1vw;
  box-sizing: border-box;
}

.card-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1vh;
  gap: 1vw;
}

.card-row2 {
  /* display: flex; */
  flex-wrap: wrap;
  margin-bottom: 1vh;
  gap: 1vw;
}

.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1vw;
  box-sizing: border-box;
}

.card01 {
  flex: 1;
  height: auto;
}

.card02 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 2vh;
}

.card-3 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 2vh;
}

.label01 {
  padding: 5px;
  border: 1px solid #b7eb8f;
  background-color: #f6ffed;
  font-size: 13px;
  color: #28b315;
}

.buttons {
  position: absolute;
  right: 1vw;
  z-index: 100;
  opacity: 0.9;
  width: auto;
}

.grid_1f_2a {
  display: grid;
  grid-template-columns: 1fr auto;
  /* margin-bottom: 2vh; */
  gap: 1vw;
}

.card03 {
  flex: 1;
  height: auto;
}

.card04 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 2vh;
}

.card07 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  margin-bottom: 2vh;
}

.table1 {
  width: 500px;
  height: auto;
  margin: 1vh 0vw;
  border: 1px solid #ccc;
  border-radius: 15px;
  font-size: 14px;
  padding: 2vh 0vw;
  text-align: center;
}

.t1_data {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  margin-bottom: 3vh;
}

.table2 {
  width: auto;
  height: 300px;
  margin: 1vh 0vw;
  /* border: 1px solid #ccc; */
  border-radius: 15px;
  font-size: 14px;
  padding: 30px 0vw;
  text-align: center;
  background-color: #fafafa;
}

.t2_data {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  font-size: 13px;
  border-bottom: 1px solid #e8e8e8;
  padding: 12px 0px;
}

.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 0px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
  margin-bottom: 2px;
}
.healthActive {
  border-bottom: 3px solid #409eff;
  color: #409eff;
  font-weight: bold;
}

.dataChart {
  /* border: 1px solid ; */
  margin-bottom: 1vh;
  border-radius: 0px;
}

.diagnosis-panel {
  min-width: 770px;
  margin-bottom: 1vh;
  border-radius: 0px;
  background: #fff;
  padding: 18px 20px;
}

.diagnosis-header {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
}

.diagnosis-title {
  margin-bottom: 8px;
  color: #1f2d3d;
  font-size: 18px;
  font-weight: 700;
}

.diagnosis-desc {
  color: #606266;
  font-size: 14px;
  line-height: 1.6;
}

.diagnosis-result {
  padding: 8px 18px;
  border: 1px solid #b7eb8f;
  border-radius: 4px;
  background: #f6ffed;
  color: #28b315;
  font-size: 15px;
  font-weight: 700;
}

.diagnosis-content {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(420px, 0.85fr);
  gap: 16px;
  padding-top: 16px;
}

.diagnosis-metric-panel,
.diagnosis-result-panel {
  min-width: 0;
  padding: 16px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fafcff;
}

.diagnosis-index-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(230px, 1fr));
  gap: 10px;
}

.diagnosis-index-card {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  min-height: 68px;
  padding: 13px 16px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
}

.diagnosis-index-name {
  color: #303133;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.45;
}

.diagnosis-index-result {
  display: flex;
  align-items: baseline;
  gap: 6px;
  white-space: nowrap;
  text-align: right;
}

.diagnosis-index-score {
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
}

.diagnosis-index-status {
  color: #606266;
  font-size: 13px;
}

.diagnosis-subtitle {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  color: #303133;
  font-size: 15px;
  font-weight: 700;
}

.diagnosis-subtitle::before {
  content: "";
  width: 3px;
  height: 14px;
  margin-right: 8px;
  border-radius: 2px;
  background: #409eff;
}

.diagnosis-subtitle-gap {
  margin-top: 16px;
}

.diagnosis-status-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(150px, 1fr));
  gap: 10px;
}

.diagnosis-status-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  min-height: 40px;
  padding: 9px 12px;
  border-radius: 4px;
  background: #fff;
  color: #606266;
  font-size: 13px;
}

.diagnosis-status-label {
  min-width: 0;
}

.diagnosis-status-item strong {
  color: #303133;
  font-weight: 700;
}

.diagnosis-exception-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(120px, 1fr));
  gap: 8px;
}

.diagnosis-exception-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  min-height: 34px;
  padding: 7px 10px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff;
  color: #606266;
  font-size: 13px;
}

.diagnosis-exception-item strong {
  color: #303133;
  font-weight: 700;
}

.dataButtons {
  position: absolute;
  right: 1vw;
  z-index: 100;
  opacity: 0.9;
  width: auto;
}

.font01 {
  font-size: 17px;
  font-weight: bold;
}

.card-50 {
  flex: 1 1 calc(10% - 1vw);
  height: 43vh;
}

.card-20 {
  flex: 1 1 calc(20% - 1vw);
  height: 43vh;
}

.chart-buttons {
  position: absolute;
  top: 0.5vw; /* 距离顶部距离 */
  right: 1vw; /* 距离右侧距离 */
  z-index: 100; /* 确保按钮在图表上方 */
  opacity: 0.9; /* 可选：轻微透明效果 */
  width: auto;
}

.card-header {
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-total {
  font-size: 24px;
  font-weight: 600;
  margin-top: 8px;
}

.pushBtn {
  margin-bottom: 20px;
  margin-left: 2vw;
  font-size: 15px;
}

.pushModel {
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.table3 {
  width: 500px;
  height: auto;
  margin: 1vh 0vw;
  border: 1px solid #ccc;
  border-radius: 15px;
  font-size: 14px;
  padding: 2vh 1vw;
  text-align: center;
}
</style>
